import { useRouter } from 'next/router';
import { useArticleContext } from '@/creditflowresearch/application/ArticlesAndStats/Article';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import SectorIndustryLabel from '@/creditflowresearch/ui/common/components/CreditFlowResearch/SectorIndustryLabel';
import {
  Description,
  Metadata,
  RestrictedSections,
  Tags,
  Title,
} from '@/creditflowresearch/ui/common/components/CreditFlowResearch/CreditFlowData';
import PageMeta from '@/creditflowresearch/ui/common/components/PageMeta';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';
import getArticleMetaSchema from './getArticleMetaSchema';

import styles from '@/creditflowresearch/ui/components/creditFlow/common/styles.module.scss';

const ArticleContent = () => {
  const {
    article,
    isInitialized,
  } = useArticleContext();
  const {
    author,
    publishedAt: date,
    sectorOrIndustry,
    subsectorOrSubindustry,
    headline,
    description,
    themes,
    sections,
  } = article;
  const { asPath: pathname } = useRouter();
  const { timeZone } = useUserTimeZoneContext();

  if (!isInitialized) {
    return (
      <Spinner isSpinnerFixed isVisible />
    );
  }

  return (
    <>
      <PageMeta
        title={ headline }
        schema={ getArticleMetaSchema(pathname, article) }
      />
      <div className={ styles.creditFlowContent }>
        <Metadata
          author={ author.name }
          date={ date }
          timeZone={ timeZone }
          authorDataTest="articleAuthor"
          dateDataTest="articleDate"
        >
          <SectorIndustryLabel
            sectorOrIndustry={ sectorOrIndustry }
            subsectorOrSubindustry={ subsectorOrSubindustry }
          />
        </Metadata>
        <Title title={ headline } dataTest="articleHeadline" />
        <div className={ styles.flexWithGap }>
          <Tags
            tags={ themes.map(({ themeName }) => themeName) }
            dataTest="articleThemes"
            tagDataTest="articleTheme"
          />
          <Description
            description={ description }
            dataTest="articleDescription"
            className={ styles.description }
          />
          <RestrictedSections sections={ sections } dataTest="articleSections" />
        </div>
      </div>
    </>
  );
};

export default ArticleContent;
